import React, {useCallback} from "react"
import {PaginatedSelector} from "@/components/paginated-selector/paginated-selector";
import {apiV2} from "@/api/axiosConfig";
import {convertV1ToV2, PaginatedResponse} from "@/types/PaginatedResponse";

type NotificationGroup = {
    id: string;
    name: string;
    userIDs: string[];
}

type NotificationGroupSelectorSimpleProps = {
    clientID?: string;
    departmentID?: string;
    selectedIDs?: string[];
    setSelectedIDs?: (selectedIDs: string[]) => void;
}

export function NotificationGroupSelectorSimple({clientID, departmentID, selectedIDs = [], setSelectedIDs}: NotificationGroupSelectorSimpleProps) {
    const headers = ["Name", "Users"]

    const getGroups = useCallback(async (search: string, page: number) => {
        const params: Record<string, string | number> = {page, limit: 10}
        if (search) params.search = search;
        if (clientID) params.clientID = clientID;
        if (departmentID) params.departmentID = departmentID;

        const res = await apiV2.get<PaginatedResponse<NotificationGroup>>("notification-groups", {params})
        return convertV1ToV2(res.data, 10)
    }, [clientID, departmentID])

    const getColumns = useCallback((group: NotificationGroup) => {
        return [group.name, String(group.userIDs?.length ?? 0)]
    }, [])

    return <PaginatedSelector
        headers={headers}
        getItems={getGroups}
        getColumns={getColumns}
        selectedIDs={selectedIDs}
        setSelectedIDs={setSelectedIDs}
        disableSelect={false}
    />
}
